/**
 * The ONE sentence for "we could not read whether this integration is
 * connected", on both surfaces that render integration rows (extension
 * Settings list, dashboard Integrations cards).
 *
 * 2026-09-16 integrations sweep, INT-03: a failed status read (a 503 on
 * GET /api/integrations or /api/integrations/slack/status) rendered as an
 * ordinary disconnected row on both surfaces, so a saved Slack connection told
 * its owner to "Connect" during an outage. Unknown is its own state, and the
 * two surfaces say the same words for it so they cannot drift.
 */
export const INTEGRATION_STATUS_UNAVAILABLE_COPY = "Couldn't check the connection.";
/**
 * Linear two-way sync arrives through the OAuth app's own webhook, which Linear
 * creates for an organization only when it authorizes the app AFTER the
 * webhook setting existed (enabled 2026-10-16; Linear's settings page: earlier
 * installations "will need to re-authorize before webhooks will be received").
 * `services/oauth-providers/linear.ts` stamps `webhookAuthorizedAt` on every
 * new authorization, so a Linear connection without it still exports but never
 * syncs back, and every surface that shows the connection asks for a reconnect
 * with these words.
 */
export function needsSyncReconnect(provider, providerMetadata) {
    if (provider === 'jira') {
        const expiresAt = Date.parse(String(providerMetadata?.webhookExpiresAt ?? ''));
        return !providerMetadata?.webhookId || !providerMetadata?.webhookSecret
            || !Number.isFinite(expiresAt) || expiresAt <= Date.now();
    }
    return provider === 'linear' && !providerMetadata?.webhookAuthorizedAt;
}
export const LINEAR_SYNC_RECONNECT_COPY = 'Reconnect Linear so status and comment changes sync back.';
export const LINEAR_SYNC_RECONNECT_EXPORT_COPY = `${LINEAR_SYNC_RECONNECT_COPY} Exports keep working.`;
export const SYNC_RECONNECT_ACTION_LABEL = 'Reconnect';
export const JIRA_SYNC_RECONNECT_COPY = 'Reconnect Jira so status and comment changes sync back.';
export const JIRA_SYNC_RECONNECT_EXPORT_COPY = `${JIRA_SYNC_RECONNECT_COPY} Exports keep working.`;
//# sourceMappingURL=integrationStatusCopy.js.map